// fixed version of https://github.com/lightsofapollo/json-templater

type JsonValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | { [key: string]: JsonValue }
  | Array<JsonValue>;

function extractValue(path: string, view: JsonValue) {
  if (view && typeof view === "object" && path in view)
    return (view as { [key: string]: JsonValue })[path];

  const parts = path.split(".");
  let part: string | undefined = parts.shift();
  let subView = view;

  while (part) {
    if (subView && typeof subView === "object" && part in subView) {
      subView = (subView as { [key: string]: JsonValue })[part];
    } else {
      return subView;
    }
    part = parts.shift();
  }

  return subView;
}

const REGEX = /\{\{([a-zA-Z.-_0-9]+)\}\}/g;
const TEMPLATE_OPEN = "{{";

export function jsonTemplater(input: string, view: JsonValue): string {
  if (input.indexOf(TEMPLATE_OPEN) === -1) return input;

  return input.replace(REGEX, (original: string, path: string) => {
    const value = extractValue(path, view);
    if (value == null) {
      return original;
    }

    if (value && typeof value === "object") {
      return "";
    }

    return String(value);
  });
}
